/** LinkId for the coverage information group in the insurance benefits verification questionnaire. */
export const COVERAGE_GROUP_LINK_ID = "coverageInformation";

/** LinkId for the coverage status question (inside the coverage group). Used to detect when coverage is set (e.g. Active / Not eligible) and to filter version history. */
export const COVERAGE_STATUS_LINK_ID = "coverageStatus";

/** LinkId for the coverage end date question (inside the coverage group). */
export const COVERAGE_END_DATE_LINK_ID = "coverageEndDate";

/** Coverage status values for insurance verification (valueCoding.code). */
export enum CoverageStatus {
  Active = "active",
  NotEligible = "not-eligible",
}

/** The insurance tiers the practice names, in `Coverage.order` order. */
export type InsuranceTier = "primary" | "secondary" | "tertiary";

/**
 * `Coverage.order` as the tier it names — the one place that says how many tiers exist.
 *
 * `order` is a `positiveInt` and may carry gaps, so an order past the tiers the product names has no
 * tier. The value type says `undefined` so that miss is one the compiler makes callers handle, since
 * TypeScript's index signatures otherwise type every lookup as a hit.
 *
 * Display surfaces capitalize this rather than keeping a parallel literal, so adding a fourth tier
 * is one edit here instead of one per surface.
 */
export const COVERAGE_TIER_BY_ORDER: Record<number, InsuranceTier | undefined> = {
  1: "primary",
  2: "secondary",
  3: "tertiary",
};

/** LinkIds for insurance snapshot stored on verification response to match coverage to intake version. */
export const VERIFICATION_SNAPSHOT_LINK_IDS = {
  insuranceCompany: "verificationSnapshotInsuranceCompany",
  insuranceId: "verificationSnapshotInsuranceId",
  insuranceGroupNumber: "verificationSnapshotInsuranceGroupNumber",
} as const;

/** Meta.tag coding systems for insurance snapshot values on verification responses. */
export const VERIFICATION_SNAPSHOT_META_TAG_SYSTEMS = {
  insuranceCompany:
    "http://quiltedhealth.com/fhir/meta-tag/verification-snapshot-insurance-company",
  insuranceId: "http://quiltedhealth.com/fhir/meta-tag/verification-snapshot-insurance-id",
  insuranceGroupNumber:
    "http://quiltedhealth.com/fhir/meta-tag/verification-snapshot-insurance-group-number",
} as const;
